import commonEChartLineData from '@/theme/default/components/charts/echarts/mixins/common/commonEChartLineData'

export default {
  mixins: [commonEChartLineData]
}
